const Config = {
    apiUrl: 'https://api.openweathermap.org/data/2.5', 
    apiKey: '538f112fd848fbd0645d783246352457'
};

module.exports = Config;